module.exports = __webpack_public_path__ + "media/assets/icons/chevron-left-b5e8f856576397a246ba6dfd3506cf7c.svg";